import { useState, useCallback } from 'react'
import { createContainer, apiFetch } from 'zn-common'

const userInfoStore = () => {
  const [userInfo, setUserInfo] = useState<any>({})
  const getUserInfo = useCallback(() => apiFetch({ url: 'agent/user/getSessionInfo.do', prefix: '/open/znClientapi' }).then(res => {
    if (!res || res._failure) return
    setUserInfo(res)
  }), [])
  return {
    userInfo,
    setUserInfo,
    getUserInfo
  }
}

export default createContainer(userInfoStore)
